
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCollisionAvoidanceHeadOn as ObiCollisionAvoidanceHeadOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-collision-avoidance-head-on.js';
 
 
 

 
 export const ObiCollisionAvoidanceHeadOn = createComponent({
   react: React,
   tagName: 'obi-collision-avoidance-head-on',
   elementClass: ObiCollisionAvoidanceHeadOnElement,
   events: {
     
   }
  });
 
 